import { BASIC_FLOOR_PLAN_SLUG } from '../../cart/floor-plan/floorPlanOffer';

// Subsets of the route-state payload that buildMapsFromLocation reads.
// React Router's Location is generic over `state`; this util only needs a few
// fields, so accepting a narrow shape avoids leaking the full Location type.
interface ServiceWithImage {
  onlineImage?: string | null;
  slug?: string | null;
  shoppingCartSlug?: string | null;
  name?: string | null;
}

interface OrderDataItem {
  services?: ServiceWithImage[];
  entityUUID?: string | null;
  entityName?: string | null;
  propertyId?: string;
}

interface EditPhotoOrderItem {
  entityUUID?: string | null;
  entityName?: string | null;
  propertyUUID?: string;
  assetId?: string;
}

interface PaymentLocationState {
  state?: {
    orderData?: OrderDataItem[];
    editPhotoOrders?: EditPhotoOrderItem[];
    freeFloorPlanImage?: string | null;
  } | null;
}

export function buildMapsFromLocation(location: PaymentLocationState | null | undefined) {
  const serviceImageMap: Record<string, string> = {};
  const entityMap: Record<string, { entityUUID: string; entityName: string }> = {};

  location?.state?.orderData?.forEach((item) => {
    item.services?.forEach((svc) => {
      if (svc.onlineImage) {
        if (svc.slug) serviceImageMap[svc.slug] = svc.onlineImage;
        if (svc.shoppingCartSlug) serviceImageMap[svc.shoppingCartSlug] = svc.onlineImage;
        if (svc.name) serviceImageMap[svc.name] = svc.onlineImage;
      }
    });
    if (item.entityUUID && item.propertyId) {
      entityMap[item.propertyId] = { entityUUID: item.entityUUID, entityName: item.entityName || '' };
    }
  });
  // DV-3808: order-service adds the free Basic Floor Plan line at creation, so
  // no cart service carries its image; checkout passes the catalog's.
  const freeFloorPlanImage = location?.state?.freeFloorPlanImage;
  if (freeFloorPlanImage) {
    serviceImageMap[BASIC_FLOOR_PLAN_SLUG] = freeFloorPlanImage;
  }
  location?.state?.editPhotoOrders?.forEach((item) => {
    if (item.entityUUID) {
      const key = item.propertyUUID || item.assetId;
      if (key) {
        entityMap[key] = { entityUUID: item.entityUUID, entityName: item.entityName || '' };
      }
    }
  });
  return { serviceImageMap, entityMap };
}
